import React from 'react';
import Stack from '@mui/material/Stack';
import {nextId} from "../utils/IdUtils";
import {newColumnStack} from "../utils/UiUtils";
import {FeaturePageItem} from "./PageComponents";

const renderFeaturesData = (featuresData) => {
  let itemsArray = [];
  for (let featureData of featuresData) {
    itemsArray.push((
      <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
        <FeaturePageItem featureData={featureData}/>
      </Stack>
    ))
  }
  return itemsArray;
}

export const FeaturesTable = ({featuresData}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      {renderFeaturesData(featuresData)}
    </Stack>)
}
